import { prop } from 'ramda';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import breakpoints from 'app/styles/constants/breakpoints';
import { startDirection, endDirection } from 'app/styles/selectors/markup';

const { widthMedium, widthSmall, widthMediumExtended, widthLarge } =
  breakpoints;
const S = {};

S.Product = styled.div`
  label: Product;

  order: ${prop('mobileOrder')};

  @media (${widthSmall}) {
    order: ${prop('tabletOrder')};
  }

  @media (${widthMediumExtended}) {
    order: ${prop('desktopOrder')};
  }
`;

S.Product.ContentWrapper = styled.div`
  label: Content;

  padding: ${({ isFree }) => (isFree ? '2.5rem' : '2rem')} 2.5rem 2.5rem;

  &:after {
    --bottom-spacing: 1.25rem;
    --top-spacing: ${({ isFree }) => (isFree ? '1.25rem' : '0.75rem')};

    display: none;
    grid-area: separator;
    content: '';
    margin-${startDirection}: 2.5rem;
    margin-${endDirection}: 2rem;
    margin-top: calc(-1 * var(--top-spacing));
    margin-bottom: calc(-1 * var(--bottom-spacing));
    height: calc(100% + var(--top-spacing) + var(--bottom-spacing));
    width: 0.1875rem;
    background-color: var(--colors-alabaster);
  }

  @media (${widthSmall}) {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    grid-template-areas: 'heading separator benefits';
    align-items: start;

    &:after {
      display: block;
    }
  }

  @media (${widthMediumExtended}) {
    display: block;
    padding: 2rem 2rem 2.5rem;

    &:after {
      display: none;
    }
  }

  @media (${widthLarge}) {
    padding: 2rem 2.5rem 2.5rem;
  }
`;

S.ProductHeading = styled.div`
  label: ProductHeading;

  grid-area: heading;
`;

S.ProductBenefits = styled.div`
  label: ProductBenefits;

  grid-area: benefits;

  @media (${widthSmall}) {
    ${({ isFree }) =>
      !isFree &&
      css`
        padding-top: 0.5rem;
      `}
  }

  @media (${widthMediumExtended}) {
    padding-top: 0;
  }
`;

S.Product.IconWrapper = styled.div`
  label: IconWrapper;

  display: ${({ isFree }) => (isFree ? 'none' : 'block')};
  margin: 0 auto 0.75rem;

  @media (${widthMedium}) {
    display: block;
  }
`;

S.Product.TitleWrapper = styled.div`
  label: TitleWrapper;

  margin-bottom: 0.5rem;
`;

export default S;
